import React from 'react'
import Navbar from './Navbar'
import Home from './Home'
import Blog from './Blog'
import Skill from './Skill'
import { BrowserRouter,Routes,Route } from 'react-router-dom'
import Project from './Project'
function Body() {
  return (

    <BrowserRouter>
     <div className='container my-7 border'>
     <div className="row">
     <Navbar/>
     </div>
     <div className="row">
       <Routes>
        <Route index element={<Home/>}/>
        <Route exact path="/" element={<Home/>}/>
        <Route exact path="/blog" element={<Blog/>}/>
        <Route exact path="/project" element={<Project/>}/>
        <Route exact path="/skill" element={<Skill/>}/>


       </Routes>
    
     </div>
    </div>
    </BrowserRouter>
   
  )
}

export default Body
